<template>
    <div>
        <div>
            <b-form-file v-if="!isBusy"
                         v-model="file"
                         size="sm"
                         placeholder="Загрузить..."
                         drop-placeholder="Перетащите файл для загрузки..."
            ></b-form-file>
            <b-progress v-if="isBusy" :value="100" variant="danger" :animated="true"></b-progress>
        </div>
        <b-list-group class="mt-3">
            <b-list-group-item v-for="fileEntry in filesInternal" v-bind:key="fileEntry.id" class="d-flex justify-content-between align-items-center">
                <b-link class="b-link-entry" :href="fileEntry.url" target="_blank">{{fileEntry.title}}</b-link>
                <b-button variant="outline" size="sm" v-on:click="removeItem(fileEntry)">
                    <b-icon-x aria-hidden="true"></b-icon-x>
                </b-button>
            </b-list-group-item>
        </b-list-group>
    </div>
</template>

<script>
    export default {
        name: "FileList",
        props: ["files"],
        data() {
            return {
                file: null,
                error: false,
                message: '',
                isBusy: false,
                filesInternal: []
            }
        },
        mounted() {
            this.filesInternal = this.files;
        },
        watch: {
            "file": {
                handler: function (data) {
                    if (data) {
                        this.upload();
                    }
                },
                immediate: true,
                deep: true
            },
            "files": {
                handler: function (data) {
                    if (data) {
                        this.filesInternal=data;
                    }
                },
                immediate: true,
                deep: true
            }
        },
        methods: {
            upload() {
                const formData = new FormData();
                formData.append('file', this.file, this.file.name);
                this.axios.post(process.env.VUE_APP_BACKEND_URL + '/api/deals/' + this.$route.params.id + "/file", formData, {})
                    .then(response => {
                        this.file = null;
                        if (response) {
                            if (response.data.error === false) {
                                this.error = false;
                                this.isBusy = false;
                                this.filesInternal.push(response.data.file);
                            } else {
                                this.error = true;
                                this.message = response.data.message;
                                this.isBusy = false;
                            }
                        }
                    })
                    .catch(error => {
                        this.file = null;
                        console.log(error)
                    });
            },
            removeItem(file) {
                if (confirm("Удалить файл " + file.title + "?")) {
                    this.error = false;
                    this.isBusy = true;
                    this.axios.delete(process.env.VUE_APP_BACKEND_URL + '/api/deals/' + this.$route.params.id + "/file/" + file.id, {})
                        .then(response => {
                            if (response) {
                                if (response.data.error === false) {
                                    this.error = false;
                                    this.isBusy = false;
                                    this.filesInternal = this.filesInternal.filter(el => el.id !== file.id);
                                } else {
                                    this.error = true;
                                    this.message = response.data.message;
                                    this.isBusy = false;
                                }
                            }
                        })
                        .catch(error => {
                            this.file = null;
                            console.log(error)
                        });
                }
            }
        }
    }
</script>

<style>
    .custom-file-label::after {
        content: 'Выбрать' !important;
    }
    .b-link-entry{
        overflow: hidden;
    }
</style>